<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-md-12">
        <div class="card card-top-line">
          <ValidationObserver v-slot="{ passes }">
            <div class="header">
              <h2>Transaction Reports</h2>
            </div>
            <div class="body">
              <form @submit.prevent="passes(reportDataSubmit)" id="basic-form">
                <div class="body">
                  <ValidationProvider
                    name="type"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <div class="country-dropdown">
                      <div
                        class="form-group form-select multiselect-grp"
                        :class="{
                          errors: errors[0],
                          success:
                            report.type &&
                            report.type.length != 0 &&
                            !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="Country">Select Report Type*</label>
                          <multiselect
                            placeholder=""
                            v-model="report.type"
                            :show-labels="false"
                            :options="reportOptions"
                            :searchable="false"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="
                              report.type &&
                              report.type.length != 0 &&
                              !errors[0]
                            "
                          ></i>
                        </span>
                      </div>
                    </div>
                  </ValidationProvider>
                  <div class="form-group datepicker">
                    <b-input-group class="flex-nowrap">
                      <div class="input-group-prepend">
                        <span class="input-group-text">From Date</span>
                        <span
                          class="input-group-text"
                          @click="$refs.birthdate1.showCalendar()"
                        >
                          <i class="icon-calendar"></i>
                        </span>
                      </div>
                      <datepicker
                        class="form-control"
                        ref="birthdate1"
                        v-model="report.from"
                        :bootstrap-styling="false"
                        placeholder=""
                        :typeable="true"
                      ></datepicker>
                    </b-input-group>
                  </div>
                  <div class="form-group datepicker">
                    <b-input-group class="flex-nowrap">
                      <div class="input-group-prepend">
                        <span class="input-group-text">To Date</span>
                        <span
                          class="input-group-text"
                          @click="$refs.birthdate1.showCalendar()"
                        >
                          <i class="icon-calendar"></i>
                        </span>
                      </div>
                      <datepicker
                        class="form-control"
                        ref="birthdate1"
                        v-model="report.to"
                        :bootstrap-styling="false"
                        placeholder=""
                        :typeable="true"
                      ></datepicker>
                    </b-input-group>
                  </div>
                </div>
                <div
                  class="d-flex flex-column flex-md-row justify-content-center"
                >
                  <b-button
                    type="submit"
                    variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                    size="lg"
                  >
                    Generate Report
                  </b-button>
                </div>
              </form>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const BreadCrumb = require("@/components/BreadCrumb.vue").default;
const { ValidationObserver, ValidationProvider } = require("vee-validate");
import "@/plugins/vee-validate";
import { mapState, mapGetters } from "vuex";
export default {
  name: "TransactionReportComponent",
  components: {
    BreadCrumb,
    ValidationObserver,
    ValidationProvider,
    Multiselect: () => import("vue-multiselect"),
    Datepicker: () => import("vuejs-datepicker"),
  },
  data() {
    return {
      report: {
        type: "",
        from: "",
        to: "",
      },
      reportOptions: [
        "Customer Report",
        "Mini Customer Report",
        "Transaction Report",
        "Mini Transaction Report",
        "Affiliate Report",
        "RemitCare Report",
        "Happy Customers Promo Report",
        "Partner Report",
        "Mini Partner Report",
        "Daily Award transaction Report",
        "CKO Transaction Report",
      ],
    };
  },
  methods: {
    reportDataSubmit() {
      console.log(this.report);
    },
  },
  mounted() {},
  computed: {
    ...mapGetters(["isLoading"]),
    ...mapState({
      apiErrors: (state) => state.auth.errors,
    }),
  },
};
</script>
